enum ElementId {
  BackgroundOverlay = "BackgroundOverlay",
}

export default ElementId;
